import { render, staticRenderFns } from "./ClubList.vue?vue&type=template&id=2a6f5184&"
import script from "./ClubList.vue?vue&type=script&lang=js&"
export * from "./ClubList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports